import React from 'react'

import ModalFormBuilder from 'Skelet/src/components/ModalFormBuilder.js'

import config from '../config.js'


export default class extends React.Component {

  render() {
    return <ModalFormBuilder
      config = {config}
      shouldShow = {this.props.shouldShow}
      close = {this.props.close}
      fields = {[{type:"textarea", dbcol:"names", placeholder:"Name or names (separated by commas)", maxLength:"5120"},
        {type:"labels", dbcol:"labels"},
        {type:"metadata", dbcol:"metadata"}]}
      required_fields = {[{dbcol:"names", name:"Namen"}]}
      validate_fields = {[{dbcol:"names", name:"Namen"}]}
      label_list = {this.props.label_list}
      api_method = "POST"
      api_endpoint = "/contact-create-multiple"
      api_block = "contact_create_multiple"
      api_block_clear = "contact_list"
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/ModalCreateContact.js